import PageDescriptionFootnote from "../Footnote";

const PageDescriptionPlano = (props: any) => {

    function renderObjectBody(data: any) {
        return { __html: data }
    }

    return (

        <section className="page-description mb-9">
            <div className="container">
                <div className="row justify-content-center">

                    {props.items?.filter((i: { Identificador: any; }) => i.Identificador === props.page).map((item: { Subtitulo: any; Descricao_x0020_Subtitulo: any; }, index: number) => (

                        <div className="col-lg-10" key={index}>
                            <div className="page-description__title mb-lg-5">
                                <h3>

                                    <span dangerouslySetInnerHTML={renderObjectBody(item?.Subtitulo)} />
                                </h3>
                            </div>
                            <div className="page-description__desc mb-7 mb-lg-9">
                                <p>

                                    <span dangerouslySetInnerHTML={renderObjectBody(item?.Descricao_x0020_Subtitulo)} />
                                </p>
                            </div>
                            <a href={props.certificado} target="_blank" className="btn btn-primary rounded px5 py-3 mt-4 mb-5" rel="noreferrer"> Baixar certificado </a>

                            <div className="page-description__midias">
                                <PageDescriptionFootnote />
                            </div>

                        </div>

                    ))}
                </div>
            </div>
        </section>
    )
};
export default PageDescriptionPlano;
